import get from 'lodash/get';
import axios from 'axios';
import config from '../configs/config';

const avoidSegmentContextMenu = ({ fields, setFields, settings }) => ({
  text: 'Add avoid segment',
  callback: (e) => {
    const url = config.routingEndpoint;
    const { lat, lng } = e.latLng;
    const latLngStr = `${lat},${lng}`;
    const params = {
      origin: latLngStr,
      destination: latLngStr,
      return: 'polyline',
      spans: 'segmentRef',
      transportMode: 'truck',
      apiKey: settings.apiKey || window.APIKEY,
    };
    axios.get(url, { params }).then((res) => {
       const segmentRef = get(
        res,
        'data.routes[0].sections[0].refReplacements',
        ''
      );
      const segmentIdres = get(
        res,
        'data.routes[0].sections[0].spans[0].segmentRef',
        ''
      ).match(/1:(\d+)#/)?.[1];
      const segmentId = `${segmentRef[1]}:${segmentIdres}`;
      const avoidSegments = fields['avoid[segments]'];
      if (avoidSegments) {
        setFields({ 'avoid[segments]': `${avoidSegments},${segmentId}` });
      } else {
        setFields({ 'avoid[segments]': segmentId });
      }
    });
  },
});

export default avoidSegmentContextMenu;
